import { inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { finalize, Observable } from 'rxjs';
import { excludeEmptyIds, getParams } from '@hglobal/common';

import { environment } from '../../../environments';
import {
  GetCoursesReq,
  SupportRequest,
  GetLocationsRes,
  CreateRequestReq,
  CreateRequestRes,
  GetRequestIdHashRes,
  SaveRequestEncryptedData,
  GetFinancialCategoriesRes,
} from '../../../models';

@Injectable()
export class SupportFormService {
  readonly #httpClient = inject(HttpClient);

  isLoading = signal<boolean>(false);

  getCourses(): Observable<GetCoursesReq> {
    this.isLoading.set(true);

    return this.#httpClient
      .get<GetCoursesReq>(`${environment.apiHost}education/my-courses/`)
      .pipe(finalize(() => this.isLoading.set(false)));
  }

  getLocations(): Observable<GetLocationsRes> {
    return this.#httpClient
      .get<GetLocationsRes>(`${environment.apiHost}ecommerce/locations/`)
      .pipe(finalize(() => this.isLoading.set(false)));
  }

  sendRequest(payload: SupportRequest): Observable<unknown> {
    this.isLoading.set(true);

    return this.#httpClient
      .post(`${environment.apiHost}support/requests/`, getParams(payload))
      .pipe(finalize(() => this.isLoading.set(false)));
  }

  getFinancialRequestIdHash(): Observable<GetRequestIdHashRes> {
    return this.#httpClient
      .get<GetRequestIdHashRes>(`${environment.apiHost}support/financial-requests/generate-hash/`)
      .pipe(finalize(() => this.isLoading.set(false)));
  }

  getFinancialCategories(): Observable<GetFinancialCategoriesRes> {
    return this.#httpClient
      .get<GetFinancialCategoriesRes>(`${environment.apiHost}support/financial-request-categories/`)
      .pipe(finalize(() => this.isLoading.set(false)));
  }

  createFinancialRequest(payload: CreateRequestReq): Observable<CreateRequestRes> {
    return this.#httpClient
      .post<CreateRequestRes>(`${environment.apiHost}support/financial-requests/`, excludeEmptyIds(payload))
      .pipe(finalize(() => this.isLoading.set(false)));
  }

  saveRequestEncryptedData(payload: SaveRequestEncryptedData): Observable<SaveRequestEncryptedData> {
    return this.#httpClient
      .post<SaveRequestEncryptedData>(
        `${environment.apiHost}financial-requests/${payload.requestIdHash}/messages/`,
        excludeEmptyIds(payload),
      )
      .pipe(finalize(() => this.isLoading.set(false)));
  }
}
